export default __webpack_public_path__ + "static/media/img_504.dcccfe59.svg";